import { Modal, Button } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useOrientation } from 'components/hooks';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateVocabCognates } from 'store/widgetWheel/actions';
import { useWidgetWheel } from 'store/widgetWheel/selectors';
import styled from 'styled-components';
import * as Sentry from '@sentry/react';

// -- Components ---------------------
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { useCurrentUser } from 'store/users/selectors';
import {
  handleDeleteWordBank,
  handleGenerateCognateWordBank,
  handleGenerateCognateWordBankNonNative,
  handleGenerateVocabularyForWordBank,
  handleUpdateWordBank,
} from 'store/word_bank/thunks';
import { useSelectorWordBank } from 'store/word_bank/selectors';
import { DeleteModal } from 'components/Dialog';
import NonSpanishVocabTab from '../../type/nonSpanishTab';
import CognatesTab from '../../type/cognatesSpanishTab';
import SpanishVocabTab from '../../type/spanishVocabTab';
import FrenchVocabTab from 'modules/word_bank/type/frenchVocabTab';

const MENU = [
  { id: 'spanish_vocab', value: 'Spanish Vocab' },
  { id: 'cognates', value: 'Cognates' },
  { id: 'non_spanish_vocab', value: 'Non Spanish Vocab' },
  { id: 'french_vocab', value: 'French Vocab' },
];

const WordBank = ({ from = {} }) => {
  const currentUser = useCurrentUser();
  const showAlert = useAlert();
  const [newItem, setNewItem] = useState({ isEditable: true });
  const [deleteVocab, setDeleteVocab] = useState({});
  const isLandscape = useOrientation();
  const { openVocabCognates } = useWidgetWheel();
  const dispatch = useDispatch();
  const [vocabularyData, setVocabularyData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [vocabularyAI, setVocabularyAI] = useState({});
  const [addVocabData, setAddVocabData] = useState({});
  const wordBankStore = useSelectorWordBank();
  const [deleteVoc, setDeleteVoc] = useState(false);
  const [dataTab, setDataTab] = useState(MENU[0].id);
  const [showWordLoader, setShowWordLoader] = useState(false);
  const [showWordEnglishLoader, setShowEnglishWordLoader] = useState(false);
  const vocabdomRef = useRef();
  const [selected_mode, setSelectedMode] = useState('english_to_spanish');

  const getDeleteItemLabel = () => {
    const type = deleteVocab?.type || dataTab;
    if (type === 'cognates') return 'cognate';
    if (type === 'non_spanish_vocab') return 'non-spanish vocabulary';
    if (type === 'french_vocab') return 'french vocabulary';
    return 'vocabulary';
  };

  const handleCloseModal = async () => {
    const filteredData = vocabularyData.filter((item) => !item.isEditable);
    setVocabularyData(filteredData);

    await dispatch(updateVocabCognates({ open: false }));
  };

  const addNewItem = () => {
    const isEditableItemExists = vocabularyData.some((item) => item.isEditable);
    if (!isEditableItemExists) {
      const updatedData = [...vocabularyData, newItem];
      setVocabularyData(updatedData);
    }
  };

  const editDataPropertyStd = (targetId, newValue, propertyName) => {
    const itemToEdit = vocabularyData.find((item) => item.id === targetId);
    const updatedData = vocabularyData.map((item) =>
      item.id === targetId
        ? {
            ...item,
            data: {
              ...item.data,
              [propertyName]: newValue,
            },
          }
        : item,
    );
    if (itemToEdit) {
      if(typeof itemToEdit.data === 'undefined'){
        itemToEdit.data = {};
      }  
      itemToEdit.data[propertyName] = newValue;
    }
    setVocabularyData(updatedData);
  };

  const handleAddVocData = (key, value) => {
    if (key === 'word') {
      const v = { ...addVocabData };
      v[key] = value;
      setAddVocabData(v);
    } else {
      const v = { ...vocabularyAI };
      v[key] = value;
      setVocabularyAI(v);
    }
  };

  const callVocAI = async () => {
    if (addVocabData?.word) {
      setShowWordLoader(true);
      const result = await dispatch(
        handleGenerateVocabularyForWordBank({
          topic: addVocabData?.word,
          user_id: currentUser?.id,
          type: dataTab,
          created_by: currentUser?.role,
        }),
      );

      if (result && !result.error) {
        showAlert('Created Successfully', 'success');
      } else {
        showAlert('No Result found', 'error');
      }
      setAddVocabData({});
      setShowWordLoader(false);
    }
  };

  const callVocWithNonSpanishModes = async () => {
    if (addVocabData?.word) {
      setShowWordLoader(true);
      const result = await dispatch(
        handleGenerateCognateWordBankNonNative({
          topic: addVocabData?.word,
          user_id: currentUser?.id,
          type: dataTab,
          mode: selected_mode,
          created_by: currentUser?.role,
        }),
      );

      if (result && !result.error) {
        showAlert('Created Successfully', 'success');
      } else {
        showAlert('No Result found', 'error');
      }
      setAddVocabData({});
      setShowWordLoader(false);
    }
  };

  useEffect(() => {
    setVocabularyData(wordBankStore);
  }, [wordBankStore]);

  const onDeleteVocab = async () => {
    await dispatch(handleDeleteWordBank(deleteVocab?.id));
    setDeleteModal(false);
    setDeleteVoc(false);
  };

  const handleUpdateData = async (data) => {
    let datas = vocabularyData.find((item) => item.id === data?.id);
    const response = await dispatch(handleUpdateWordBank(datas));
    if (response?.id) {
      showAlert('Updated Successfully', 'success');
    } else {
      showAlert('Updated Failed', 'error');
    }
  };

  const filteredVocabularyData = vocabularyData.filter(
    (item) => item.type === dataTab || item.isEditable,
  );

  const callCognetsVocAI = async (type = '') => {
    try {
      if (addVocabData?.word) {
        if (type === 'english') {
          setShowEnglishWordLoader(true);
        } else {
          setShowWordLoader(true);
        }

        const result = await dispatch(
          handleGenerateCognateWordBank({
            topic: addVocabData?.word,
            type: dataTab,
            user_id: currentUser?.id,
            language: type,
          }),
        );

        if (result && !result.error) {
          showAlert('Created Successfully', 'success');

          if (vocabdomRef) {
            vocabdomRef.current.scrollTo(0, vocabdomRef.current.scrollHeight);
          }
        } else {
          showAlert('Updated Successfully', 'success');
        }
        setAddVocabData({});
      }
    } catch (error) {
      Sentry.captureException(`638 Error in callCognetsVocAI: ${error}`);
    } finally {
      setShowEnglishWordLoader(false);
      setShowWordLoader(false);
    }
  };

  return (
    <>
      <DeleteModal
        deleteToggle={deleteModal}
        loading={deleteVoc}
        onDelete={() => {
          onDeleteVocab();
          setDeleteVoc(true);
        }}
        setDeleteToggle={setDeleteModal}
        message={`Are you sure you want to remove this ${
          deleteVocab?.data && deleteVocab?.data?.word ? `"${deleteVocab.data.word}"` : ''
        } ${getDeleteItemLabel()}?`}
      />
      <Modal
        className={`${isLandscape ? 'landscape-vocabModal' : ''} vocabulModal`}
        open={openVocabCognates?.open}
        onClose={handleCloseModal}
        style={{
          height: '100%',
          width: '100%',
          backgroundColor: 'transparent',
        }}
        disableEscapeKeyDown
        disableBackdropClick
      >
        <ModalContent isLandscape={isLandscape} className="vocabulContents">
          <div className="flex items-center gap-10px mb-10px justify-between w-full">
            <div className='flex items-center gap-10px'>
              {MENU?.map((ele) => (
                <Button
                  key={ele.id}
                  className={
                    dataTab === ele?.id
                      ? 'selected selected-background-color text-white'
                      : 'unselected-color'
                  }
                  onClick={() => {
                    const filteredData = vocabularyData?.filter((item) => !item.isEditable);
                    setVocabularyData(filteredData);
                    setDataTab(ele?.id);
                  }}
                >
                  {ele?.value}
                </Button>
              ))}
            </div>

            <div
              style={{ paddingRight: '8px', marginBottom: '10px' }}
              className="flex items-center justify-end"
            >
              <Close color="secondary" onClick={handleCloseModal} className="vocablaryClose" />
            </div>
          </div>

          <div
            className="vocabulTableUpr vocab-table-upar vocInMobile vocabStrokeWidth"
            style={{ maxHeight: 550, overflowY: 'scroll' }}
          >
            {dataTab === 'spanish_vocab' && (
              <SpanishVocabTab
                vocabularyData={filteredVocabularyData}
                showWordLoader={showWordLoader}
                callVocAI={callVocAI}
                handleAddVocData={handleAddVocData}
                editDataPropertyStd={editDataPropertyStd}
                handleUpdateData={handleUpdateData}
                addNewItem={addNewItem}
                setDeleteModal={setDeleteModal}
                setDeleteVocab={setDeleteVocab}
                currentUser={currentUser}
                from={from}
              />
            )}

            {dataTab === 'cognates' && (
              <CognatesTab
                vocabularyData={filteredVocabularyData}
                showWordLoader={showWordLoader}
                callVocAI={callCognetsVocAI}
                handleAddVocData={handleAddVocData}
                editDataProperty={editDataPropertyStd}
                handleUpdateData={handleUpdateData}
                addNewItem={addNewItem}
                setDeleteModal={setDeleteModal}
                setDeleteVocab={setDeleteVocab}
                currentUser={currentUser}
                showWordEnglishLoader={showWordEnglishLoader}
                from={from}
              />
            )}

            {dataTab === 'non_spanish_vocab' && (
              <NonSpanishVocabTab
                vocabularyData={filteredVocabularyData}
                showWordLoader={showWordLoader}
                callVocAI={callVocWithNonSpanishModes}
                handleAddVocData={handleAddVocData}
                editDataProperty={editDataPropertyStd}
                handleUpdateData={handleUpdateData}
                addNewItem={addNewItem}
                setDeleteModal={setDeleteModal}
                setDeleteVocab={setDeleteVocab}
                currentUser={currentUser}
                selected_mode={selected_mode}
                setSelectedMode={setSelectedMode}
                from={from}
              />
            )}

            {dataTab === 'french_vocab' && (
              <FrenchVocabTab
                vocabularyData={filteredVocabularyData}
                showWordLoader={showWordLoader}
                callVocAI={callVocWithNonSpanishModes}
                handleAddVocData={handleAddVocData}
                editDataProperty={editDataPropertyStd}
                handleUpdateData={handleUpdateData}
                addNewItem={addNewItem}
                setDeleteModal={setDeleteModal}
                setDeleteVocab={setDeleteVocab}
                currentUser={currentUser}
                selected_mode={selected_mode}
                setSelectedMode={setSelectedMode}
                from={from}
              />
            )}
          </div>
        </ModalContent>
      </Modal>
    </>
  );
};

export default WordBank;

const ModalContent = styled.div`
  left: 50%;
  max-width: 100vw;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  border-radius: 10px;
  background-color: #fff;
  padding: 10px;
  transform: translate(-50%, -50%);
  top: 50%;
  @media (max-width: 1366px) {
    width: 90vw;
  }

  @media (max-width: 500px) {
    max-height: 560px;
  }
`;
